import { Level2Wrapper } from '../common/Level2Wrapper';
import { GenericSubSection } from '../common/GenericSubSection';
import { useLevel1SectionData } from '../../hooks/useLevel1Section';
import { useExteriorSectionData } from '../../hooks/useExteriorSection';
import { useViewedVehicle } from 'pages/Admin/ViewVehicle/hooks/useViewedVehicle';
import { Section } from 'services/api/vehicle-sections/types';

export const DriveCycles = () => {
  const { subSections } = useLevel1SectionData('drive_cycles');
  const vehicle = useViewedVehicle();

  const { subSections: exteriorSubSections } = useExteriorSectionData('exterior');

  const vehicleRunsAndDrivesSection = subSections.how_vehicle_runs_overall;
  const vehicleRunsAndDrivesSubSections = [
    subSections.engine_light_acceleration,
    subSections.engine_medium_acceleration,
    subSections.engine_heavy_acceleration,
    subSections.engine_noises
  ].filter(section => !!section && !!section.grade);

  const vehicleRunsAndDrivesCollapsed =
    vehicleRunsAndDrivesSection.grade === 'good' && vehicleRunsAndDrivesSubSections.every(s => s.grade === 'good');

  const transmissionShiftSection = subSections.how_transmission_shifts;
  const transmissionShiftSubSections = [
    subSections.transmission_light_acceleration,
    subSections.transmission_medium_acceleration,
    subSections.transmission_heavy_acceleration,
    subSections.transmission_shudder
  ].filter(section => !!section && !!section.grade);

  const transmissionShiftCollapsed =
    transmissionShiftSection.grade === 'good' && transmissionShiftSubSections.every(s => s.grade === 'good');

  const generalSections = [
    exteriorSubSections.suspension_alterations,
    exteriorSubSections.suspension_operations,
    exteriorSubSections.exhaust_sounds_factory,
    exteriorSubSections.catalytic_converter_present,
    subSections['3_point_turn_cv_reserve_test'],
    subSections.vehicle_breaking
  ].filter(Boolean);

  const isManual = vehicle?.transmission?.toLowerCase().startsWith('manual');
  const is4WD = vehicle?.drive_train?.toLowerCase() === '4wd';

  const manualSections = [
    subSections.position_of_clutch_pedal,
    subSections.clutch_engages_in_gear,
    subSections.manual_transmission_engages_every_gear
  ].filter(Boolean);

  const fourWheelDriveSections = [subSections.engage_in_low_4x4, subSections.engage_in_high_4x4].filter(Boolean);

  const shouldRenderNestedSection = (section: Section, nested: Section[]) => {
    if (!section) return false;
    if (!!section.grade) return true;
    return nested.length > 0;
  };

  return (
    <Level2Wrapper flex="1 1 100%" label="Drive Cycles">
      {shouldRenderNestedSection(vehicleRunsAndDrivesSection, vehicleRunsAndDrivesSubSections) && (
        <GenericSubSection
          collapsed={vehicleRunsAndDrivesCollapsed}
          section={vehicleRunsAndDrivesSection}
          additionalData={{ nestedSections: vehicleRunsAndDrivesSubSections }}
        />
      )}
      {shouldRenderNestedSection(transmissionShiftSection, transmissionShiftSubSections) && (
        <GenericSubSection
          collapsed={transmissionShiftCollapsed}
          section={transmissionShiftSection}
          additionalData={{ nestedSections: transmissionShiftSubSections }}
        />
      )}
      {generalSections.map(section => {
        if (!section.grade) return null;
        return <GenericSubSection key={section.id} section={section} />;
      })}
      {isManual &&
        manualSections.map((section: any) => {
          if (!section.grade) return null;
          return <GenericSubSection key={section.id} section={section} />;
        })}
      {is4WD &&
        fourWheelDriveSections.map((section: any) => {
          if (!section.grade) return null;
          return <GenericSubSection key={section.id} section={section} />;
        })}
      {subSections.how_engine_runs_overall && subSections.how_engine_runs_overall.grade && (
        <GenericSubSection section={subSections.how_engine_runs_overall} />
      )}
    </Level2Wrapper>
  );
};
